import { render, staticRenderFns } from "./ViewMethodInterventions.vue?vue&type=template&id=03b71290&"
import script from "./ViewMethodInterventions.vue?vue&type=script&lang=js&"
export * from "./ViewMethodInterventions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports